import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ErrorBoundary } from "./components/feedback/ErrorBoundary";
import { Dashboard } from "./components/dashboard/Dashboard";
import { NuovoOrdine } from "./components/nuovo-ordine/NuovoOrdine";
import { OrdineCompletato } from "./components/ordine/OrdineCompletato";
import { Ordini } from "./components/ordini/Ordini";
import { OrdineDettaglio } from "./components/ordini/OrdineDettaglio";
import { Clienti } from "./components/clienti/Clienti";
import { ClienteProfilo } from "./components/clienti/ClienteProfilo";
import { Prodotti } from "./components/prodotti/Prodotti";
import { Profilo } from "./components/profilo/Profilo";
import { AuthHandler } from "./components/auth/AuthHandler";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import "./index.css";

// ----------------------------------------------------------------------------

export function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/auth" element={<AuthHandler />} />
          <Route
            path="/nuovo-ordine"
            element={
              <ProtectedRoute>
                <NuovoOrdine />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ordine/:id"
            element={
              <ProtectedRoute>
                <OrdineCompletato />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ordini"
            element={
              <ProtectedRoute>
                <Ordini />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ordini/:id"
            element={
              <ProtectedRoute>
                <OrdineDettaglio />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clienti"
            element={
              <ProtectedRoute>
                <Clienti />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clienti/:id"
            element={
              <ProtectedRoute>
                <ClienteProfilo />
              </ProtectedRoute>
            }
          />
          <Route
            path="/prodotti"
            element={
              <ProtectedRoute>
                <Prodotti />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profilo"
            element={
              <ProtectedRoute>
                <Profilo />
              </ProtectedRoute>
            }
          />
          {/* Catch all route - redirect to dashboard */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
